


function EspacioBlanco(a: any) {
    //console.log("a...trimmer.", a);
    let trimmedArr = a.map((val: any) => {
      return val.trim();
    });

    console.log("trimmedArr.....", trimmedArr);
    return trimmedArr;
  }
  export default EspacioBlanco;